import { AppPhase, GameType } from '../../models/communication/app-enums.model';
import { AppEventType } from '../../models/communication/app-events.model';
import { DragonTigerCardPosition, DragonTigerOutcome } from '../main-games/dragon-tiger/dragon-tiger.model';

export const configuration = {
    gameType: GameType.DragonTiger
};

export const demoEvents = [
    {
        name: AppEventType.GamePhaseChange,
        data: {
            phase: AppPhase.DealingCards,
            subPhase: 1
        }
    },
    {
        name: AppEventType.CardDealt,
        data: {
            card: 402,
            cardPosition: DragonTigerCardPosition.DragonCard,
            dragonHandValue: 2,
            tigerHandValue: 0,
            nextCardPosition: DragonTigerCardPosition.TigerCard
        }
    },
    [
        {
            name: AppEventType.CardDealt,
            data: {
                card: 402,
                cardPosition: DragonTigerCardPosition.TigerCard,
                dragonHandValue: 2,
                tigerHandValue: 2,
                outcome: DragonTigerOutcome.DragonWin
            }
        },
        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.RoundEnd,
                outcome: DragonTigerOutcome.DragonWin
            }
        }
    ]
];
